import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import DocumentationSidebar from "../../../../Layout/DocumentationSidebar";
import TopMenu from "../../TopMenu";
import TableDocument from "../../TableDocument";
import FilterModal from "../../../../Components/Common/FilterModal";
import { get } from "../../../../utils/api";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";
import { useUser } from "../../../../context/AuthContext";
import ApprovalSidebar from "../../../../Layout/ApporvalSidebar";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import BusinessViewPage from "../../BusinessTravelView";

const BusinessTravelDocuments = () => {
  const { user } = useUser();
  const approvalUrl = "/scope3/businessTravelEmissions/apporveOrReject";
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  const [selectedFacility, setSelectedFacility] = useState([]);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [filterObj, setFilterObj] = useState({});
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [url, setUrl] = useState("road");
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [fromDate, setFromDate] = useState({
    month: 1,
    year: currentYear,
  });
  const [toDate, setToDate] = useState({
    month: currentDate.getMonth() + 1,
    year: currentYear,
  });

  const [travelFilter, setTravelFilter] = useState({
    origin: "",
    destination: "",
    employeePosition: "",
    travelMode: "",
  });

  const handleFilterChange = (newFilterObj) => {
    setFilterObj(newFilterObj);
  };

  const handleToggle = (option, url) => {
    setSelectedOption(option);
    setUrl(url);
  };

  let filtersToApply = {};

  const fetchData = async (
    filters = isFiltersApplied ? filtersToApply : {}
  ) => {
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        facilityList: selectedFacility.join(","),
        page,
        limit: 10,
      }).toString();

      const response = await get(
        `/scope3/businessTravelEmissions/apporevelist?${queryParams}`
      );
      setData(response.data.data);
      setTotalPages(response.data.totalPages);
      setPage(response?.data?.currentPage);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, url, fromDate, toDate, selectedFacility]);

  const fetchFilter = async () => {
    try {
      const response = await get(`/scope3/businessTravelEmissions/filter`);
      setTravelFilter({
        origin: response.data?.data?.origin,
        destination: response.data?.data?.destination,
        employeePosition: response.data?.data?.employeePosition,
        travelMode: response.data?.data?.travelMode,
      });
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchFilter();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const viewheaders = [
    {
      key: "travelType",
      title: "Travel Type",
    },

    {
      key: "dateOfTravel",
      title: "Date of Travel",
      render: (data) =>
        data?.dateOfTravel
          ? new Date(data.dateOfTravel).toLocaleDateString()
          : "-",
    },
    {
      key: "employeeName",
      title: "Employee Name",
    },
    {
      key: "employeePosition",
      title: "Employee Position",
    },
    {
      key: "travelMode",
      title: "Travel Mode",
    },
    {
      key: "origin",
      title: "Origin",
    },
    {
      key: "destination",
      title: "Destination",
    },
    {
      key: "travelLocations",
      title: "Travel Locations",
      render: (data) =>
        Array.isArray(data?.travelLocations) && data.travelLocations.length > 0
          ? data.travelLocations.join(", ")
          : "-",
    },
    // {
    //   key: "travelDuration",
    //   title: "Travel Duration",
    //   render: (data) =>
    //     data?.travelDuration?.value
    //       ? `${data.travelDuration.value} ${data.travelDuration.unit || "Days"}`
    //       : "-",
    // },
    {
      key: "airDetailsClass",
      title: "Air Class",
    },
    {
      key: "roadDetailsVehicle",
      title: "Road Vehicle",
    },
    {
      key: "railDetails.vehicleType",
      title: "Rail Vehicle Type",
      render: (data) => data?.railDetails?.vehicleType || "-",
    },
    {
      key: "waterDetails.vehicleType",
      title: "Water Vehicle Type",
      render: (data) => data?.waterDetails?.vehicleType || "-",
    },
    {
      key: "country",
      title: "Country",
    },
    {
      key: "numberOfNights",
      title: "Number of Nights",
      render: (data) =>
        data?.numberOfNights ? `${data.numberOfNights} Night(s)` : "-",
    },
  ];

  const heading = [
    {
      title: "Date",
      key: "createdAt",
    },
    user?.companyAdmin
      ? {
          title: "Facility",
          key: "facilityName",
        }
      : null,
    {
      title: "Employee Name",
      key: "employeeName",
    },
    {
      title: "Employee Position",
      key: "employeePosition",
    },
    // {
    //   title: "Origin",
    //   key: "origin",
    // },
    // {
    //   title: "Destination",
    //   key: "destination",
    // },
    {
      title: "Travel Date",
      key: "dateOfTravel",
    },
    {
      title: "Status",
      key: "requestStatus",
    },
    {
      title: "CreatedBy",
      key: "createdBy",
    },
  ].filter(Boolean);

  const filterData = [
    { title: "Date", type: "date", key: "createdAt", value: [] },
    {
      title: "Employee Position",
      type: "option",
      key: "employeePosition",
      value: travelFilter?.employeePosition
        ? travelFilter.employeePosition
        : [],
    },
    {
      title: "Origin",
      type: "option",
      key: "origin",
      value: travelFilter?.origin ? travelFilter.origin : [],
    },
    {
      title: "Destination",
      type: "option",
      key: "destination",
      value: travelFilter?.destination ? travelFilter.destination : [],
    },
    {
      title: "Mode of Travel",
      type: "option",
      key: "travelMode",
      value: travelFilter?.travelMode ? travelFilter.travelMode : [],
    },
  ].filter(Boolean);

  const fetchDataCallback = async () => {
    await fetchData();
  };
  const toggleData = [];
  return (
    <MainDashboardLayout sidebar={<ApprovalSidebar />}>
      {/* <Unauthorized requiredModule="Documentation"> */}
      <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
      <TopMenu
        {...{
          setDrawerFilterOpen: setIsFilterModalOpen,
          selectedMonth,
          setSelectedMonth,
          selectedYear,
          setSelectedYear,
          selectedOption,
          handleToggle,
          filterApplied: isFiltersApplied,
          toggleData: toggleData,
          fromDate,
          setFromDate,
          toDate,
          setToDate,
          selectedFacility,
          setSelectedFacility,
        }}
        heading={"Business Travel"}
      />
      <TableDocument
        data={data}
        totalPages={totalPages}
        page={page}
        handleChangePage={handleChangePage}
        headers={heading}
        columnWidth={
          user?.companyAdmin
            ? "12% 13% 12.5% 13% 12.5% 12.5% 12.5% 9%"
            : "12% 20% 13% 15% 15% 12.5% 12.5%"
        }
        setsnackOpen={setsnackOpen}
        fetchDataCallback={fetchDataCallback}
        apiUrl={approvalUrl}
        viewheaders={viewheaders}
        viewPage={BusinessViewPage}
      />
      <FilterModal
        isOpen={isFilterModalOpen}
        onClose={() => setIsFilterModalOpen(false)}
        filters={filterData}
        onFilterChange={handleFilterChange}
        title="Filter"
      />
      {/* </Unauthorized> */}
    </MainDashboardLayout>
  );
};

export default BusinessTravelDocuments;
